/** CoStar.Api.Autocomplete.Geography.DataContracts.Enums.GeographyMatchType */
export var GeographyMatchType;
(function (GeographyMatchType) {
    GeographyMatchType[GeographyMatchType["Unknown"] = 0] = "Unknown";
    GeographyMatchType[GeographyMatchType["PostalCode"] = 2] = "PostalCode";
    GeographyMatchType[GeographyMatchType["City"] = 3] = "City";
    GeographyMatchType[GeographyMatchType["Submarket"] = 5] = "Submarket";
    GeographyMatchType[GeographyMatchType["County"] = 10] = "County";
    GeographyMatchType[GeographyMatchType["Subdivision"] = 11] = "Subdivision";
    GeographyMatchType[GeographyMatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyMatchType[GeographyMatchType["Region"] = 17] = "Region";
    GeographyMatchType[GeographyMatchType["Cluster"] = 21] = "Cluster";
})(GeographyMatchType || (GeographyMatchType = {}));
